import { cn } from "../lib/utils";

const STYLES = {
  succeeded: "bg-emerald-500/12 text-emerald-300 border-emerald-500/30",
  failed: "bg-red-500/12 text-red-300 border-red-500/30",
  pending: "bg-amber-500/12 text-amber-300 border-amber-500/30",
  default: "bg-white/[0.05] text-white/70 border-white/10",
};

export function StatusPill({ status, label, className }) {
  const style = STYLES[status] || STYLES.default;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        style,
        className,
      )}
      data-testid={`status-pill-${status}`}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          status === "succeeded" && "bg-emerald-400",
          status === "failed" && "bg-red-400",
          status === "pending" && "bg-amber-400",
        )}
      />
      {label || status}
    </span>
  );
}

export default StatusPill;
